import api from './api'

interface UserProfileParams {
  username?: string;
  avatar?: string;
}

export interface UserProfileProps {
  username?: string;
  avatar?: string;
}

export const userProfile = async (props: UserProfileProps) => {
  const params: UserProfileParams = props;
  const res = await api.post<unknown>('/users/profile', params)
  return res
}
